import React from 'react';

function ToolsNewWebinar({
                 onAddCheckedUsersClick,
                 count
               }) {

  return (
    <div className="admin_list">
      <h5>Users (<span>{count}</span>)</h5>
      <a className="button_classic" onClick={onAddCheckedUsersClick}>Add Users</a>
    </div>
  );
}

export default ToolsNewWebinar;



// WEBPACK FOOTER //
// ./src/components/AddUsersWebinar/ToolsNewWebinar.jsx